import React, { useEffect, useState, useCallback } from "react";
import { Box } from "@chakra-ui/layout";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Logo } from "../logo";
import { Videos } from "../videos";
import { Photos } from "../photos";
import { SearchBar } from "../searchBar";
import { Spinner } from "@chakra-ui/react";
import { usePixabaySearch, usePixabaySearchVideos } from "../../hooks";
import useScrollPosition from "@react-hook/window-scroll";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import "../../styles/styles.scss";

const LoadingSpinner = () => (
  <Box display="flex" justifyContent="center" m={10}>
    <Spinner />
  </Box>
);

const theme = extendTheme({
  styles: {
    global: {
      ".video-react-fluid": {
        padding: "0!important",
      },
      ".bpb": {
        display: "none",
      },
    },
  },
});

export function Main(props: any) {
  const [query, setQuery] = useState({ q: "", index: 0 });
  const {
    loading,
    photos,
    search,
    fetchMoreData,
    loadmore,
    setLoadMore,
    setPage,
  } = usePixabaySearch();
  const {
    videoData,
    loadmore: videoLoadMore,
    fetchMoreData: fetchMoreVideoData,
    search: searchQuery,
    setPage: setPageVideo
  } = usePixabaySearchVideos();
  const [itemSelected, setItemSelected] = useState(false);
  const scroll = useScrollPosition();
  const [tabIndex, setTabIndex] = useState(0);
  const [itemSelectedUrl, setItemSelectedUrl] = useState({
    item_url: "",
    item_type: "",
    thumbnail: "",
  });

  const [scrollTimeout, setScrollTimeout]: any = useState<number>(0);

  useEffect(() => {
    // Clear the previous timeout (if any) when the component re-renders
    if (scrollTimeout !== null) {
      clearTimeout(scrollTimeout);
    }

    // Set a new timeout to handle the scroll event after 300 milliseconds
    const timeoutId = setTimeout(() => {
      var totalPageHeight = document.body.scrollHeight;
      var scrollPoint = window.scrollY + window.innerHeight;
      let percentage = (scrollPoint / totalPageHeight) * 100;

      if (percentage >= 99.5) {
        if (tabIndex === 1) {
          const retry = async (fn: any, maxAttempts: any) => {
          const execute = async (attempt: any) => {
            try {
              return await fn();
            } catch (err) {
              if (attempt <= maxAttempts) {
                const nextAttempt = attempt + 1;
                const delayInSeconds = Math.max(
                  Math.min(
                    Math.pow(2, nextAttempt) +
                      randInt(-nextAttempt, nextAttempt),
                    600
                  ),
                  1
                );
                console.error(
                  `Retrying after ${delayInSeconds} seconds due to:`,
                  err
                );
                return delay(() => execute(nextAttempt), delayInSeconds * 1000);
              } else {
                console.info(err);
              }
            }
          };
          return execute(1);
        };

        const delay = (fn: any, ms: any) =>
          new Promise((resolve) => setTimeout(() => resolve(fn()), ms));

        const randInt = (min: any, max: any) =>
          Math.floor(Math.random() * (max - min + 1) + min);

        retry(fetchMoreVideoData, 10);
      } else {
        const retry = async (fn: any, maxAttempts: any) => {
          const execute = async (attempt: any) => {
            try {
              return await fn();
            } catch (err) {
              if (attempt <= maxAttempts) {
                const nextAttempt = attempt + 1;
                const delayInSeconds = Math.max(
                  Math.min(
                    Math.pow(2, nextAttempt) +
                      randInt(-nextAttempt, nextAttempt),
                    600
                  ),
                  1
                );
                console.error(
                  `Retrying after ${delayInSeconds} seconds due to:`,
                  err
                );
                return delay(() => execute(nextAttempt), delayInSeconds * 1000);
              } else {
                console.info(err);
              }
            }
          };
          return execute(1);
        };

        const delay = (fn: any, ms: any) =>
          new Promise((resolve) => setTimeout(() => resolve(fn()), ms));

        const randInt = (min: any, max: any) =>
          Math.floor(Math.random() * (max - min + 1) + min);

        retry(fetchMoreData, 10);
      }
    }
  }, 300)

  setScrollTimeout(timeoutId);

    // Clean up the timeout when the component unmounts
    return () => {
      if (scrollTimeout !== null) {
        clearTimeout(scrollTimeout);
      }
    };
  }, [scroll, tabIndex]);


  const onItemSelectedCb = useCallback(
    (isSelected: any) => {
      setItemSelected(isSelected);
    },
    [itemSelected]
  );

  const onSelectedTemUrlCb = useCallback(
    (obj: any) => {
      setItemSelectedUrl(obj);
    },
    [itemSelectedUrl]
  );

  const handleTabsChange = (index: any) => {
    setPage(0);
    setPageVideo(0)
    setLoadMore(true);
    setTabIndex(index);
    setItemSelected(false);
    let q = query.q || "";
    search({ q: q, index: index });
    searchQuery({ q: q, index: index });
  };

  const handleQueryChange = (value: any) => {
    setLoadMore(true);
    setQuery({ q: value, index: tabIndex });
  };

  const handleSubmit = (empty: boolean) => {
    setPage(0);
    setPageVideo(0)
    setLoadMore(true);
    if (empty) {
      search({ q: "", index: tabIndex });
      searchQuery({ q: "", index: tabIndex });
    } else {
      let q = query.q || "";
      search({ q: q, index: tabIndex });
      searchQuery({ q: q, index: tabIndex });
    }
    setItemSelected(false);
  };

  //Method to get the return json Add button
  const geturl = (e: any) => {
    if (itemSelectedUrl.item_type === "image") {
      const returnJson = {
        action: "create",
        type: "overlay",
        file: itemSelectedUrl.item_url,
      };
      props.getPexelsPhotoData(returnJson);

      if (window.vlogr) {
        window.vlogr.addData(1, JSON.stringify(returnJson));
      }
      if (window.webkit) {
        window.webkit.messageHandlers.addData.postMessage(returnJson);
      }

      if (window.top) {
        window.top.postMessage(returnJson, "*");
      }
    } else {
      const returnJson = {
        action: "create",
        type: "video",
        file: itemSelectedUrl.item_url,
      };
      props.getPexelsPhotoData(returnJson);
      if (window.vlogr) {
        window.vlogr.addData(1, JSON.stringify(returnJson));
      }
      if (window.webkit) {
        window.webkit.messageHandlers.addData.postMessage(returnJson);
      }
    }

    setItemSelected(false);
    setItemSelectedUrl({ item_url: "", item_type: "", thumbnail: "" });
  };

  return (
    <ChakraProvider theme={theme}>
      <div className="container">
        <HelmetProvider>
          <Helmet>
            <link rel="icon" href="/favicon.ico" />
          </Helmet>
        </HelmetProvider>

        <Box
          zIndex={100}
          paddingTop="10px"
          position="sticky"
          top={0}
          background="white"
          paddingBottom="15px"
        >
          <Box height="50px" marginInline="16px">
            <Logo />
          </Box>
          <Box height="100%" marginInline="20px">
            <SearchBar
              query={query.q}
              onChange={handleQueryChange}
              /*@ts-ignore*/
              onSubmit={handleSubmit}
            />
          </Box>
          <div>
            <div
              style={{
                position: "sticky",
                top: 0,
                zIndex: 2000,
                background: "#ffffff",
              }}
            >
              <div className="header">
                <div className={`tab-navigation ${tabIndex === 0 ? "active" : ""}`}>
                  <button
                    className={`tab-button ${tabIndex === 0 ? "active" : ""}`}
                    onClick={() => handleTabsChange(0)}
                  >
                    Photo
                  </button>
                </div>
                <div className={`tab-navigation ${tabIndex === 1 ? "active" : ""}`}>
                  <button
                    className={`tab-button ${tabIndex === 1 ? "active" : ""}`}
                    onClick={() => handleTabsChange(1)}
                  >
                    Video
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Box>

        {tabIndex === 0 && (
          <Box height="100%" marginInline="20px" style={{ cursor: "pointer" }}>
            {photos && (
              <>
                {/*@ts-ignore */}
                <Photos
                  photos={photos}
                  onItemSelectedCb={onItemSelectedCb}
                  onSelectedTemUrlCb={onSelectedTemUrlCb}
                  itemSelected={itemSelected}
                  itemSelectedUrl={itemSelectedUrl}
                  getPexelsPhotoData={props.getPexelsPhotoData}
                  onDragStart={props.onDragStart}
                  onDragEnd={props.onDragEnd}
                />
              </>
            )}
            {loadmore ? <LoadingSpinner /> : <></>}
          </Box>
        )}

        {tabIndex === 1 && (
          <Box height="100%" marginInline="20px" style={{ cursor: "pointer" }}>
            {videoData && (
              <>
                <Videos
                  videos={videoData}
                  onItemSelectedCb={onItemSelectedCb}
                  onSelectedTemUrlCb={onSelectedTemUrlCb}
                  itemSelected={itemSelected}
                  itemSelectedUrl={itemSelectedUrl}
                  getPexelsPhotoData={props.getPexelsPhotoData}
                  onDragStart={props.onDragStart}
                  onDragEnd={props.onDragEnd}
                />
              </>
            )}
            {videoLoadMore ? <LoadingSpinner /> : <></>}
          </Box>
        )}
      </div>
    </ChakraProvider>
  );
}
